import React, { useEffect, useState } from 'react';
import LabelInput from '../labelInput/labelInput';

const ConstantInput = ({
  regex = null,
  errorMsg,
  disabled,
  type,
  label,
  value = '',
  required,
  minLength,
  maxLength,
  min,
  max,
  onFocus,
  onKeyPress,
  isStarRequired,
  placeholder='',
  handleChange,
  fullWidth = false,
  pattern = null,
  isNotZero = null,
  blockError = false,
  className = null,
  isPrefix = false,
  prefixText = '',
  tenDigitsValidation = false,
  checkDigits = false,
                         decimal = '',
                         step = '',
                         onPaste,
                         onCopy,
                         autoComplete
}) => {
  const [isValue, setIsValue] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => setIsValue(value), [value]);
  useEffect(() => {
    setIsError(blockError);
    // setIsValue(''); //not sure why its removing value, so commented
  }, [blockError]);

  const handleNameBlur = (val) => {
    if (regex !== null) {
      if (regex) {
        setIsError(false);
        setIsValue(val);
      } else {
        setIsError(true);
      }
    }
    if (isNotZero !== null && isNotZero !== undefined) {
      setIsValue(val.replace(/^0+/, ''));
    }
  };

  const handleInputChange = (val) => {
    // Enforce maxLength for numeric input
    if (type === 'number' && maxLength) {
      val = val.slice(0, maxLength);
    }

    // Remove non-numeric characters if checkDigits is true
    if (checkDigits) {
      val = val.replace(/[^0-9]/g, '');
    }
    setIsValue(val);
    if (handleChange) handleChange(val);
  };
  

  return (
    <LabelInput
      label={label}
      errorMsg={errorMsg}
      placeholder={placeholder}
      inputValue={isValue}
      type={type}
      isError={isError}
      handleChange={(e) => {
        if(checkDigits){
          const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
          handleInputChange(value);
          e.target.value = value;
        } else {
          handleInputChange(e.target.value);
        }
      }}
      className={`${
        (required && required == 1)?
        ((isValue && String(isValue).length) || (value && String(value).length)) ? '' : 'empty activeAnkInput'
        :
        ((isValue && String(isValue).length) || (value && String(value).length)) ? '' : 'empty'
      } ${className}`}
      onBlur={() => handleNameBlur(isValue)}
      onKeyPress={onKeyPress}
      maxLength={maxLength}
      minLength={minLength}
      min={min}
      max={max}
      isStarRequired={isStarRequired}
      required={required}
      disabled={disabled}
      fullWidth={fullWidth}
      pattern={pattern}
      isPrefix={isPrefix}
      prefixText={prefixText}
      onFocus={onFocus}
      tenDigitsValidation={tenDigitsValidation}
      step={step}
      inputMode={decimal}
      onPaste={onPaste}
      onCopy={onCopy}
      autoComplete={autoComplete}
    />
  );
};

export default ConstantInput;
